
//for loading and messages alert
import React, { useContext, useState } from 'react';


const PupupContext = React.createContext();

export function usePopUpContext() {
    return useContext(PupupContext);
}

export function PupupContextProvider(props) {

const [popupMessage,setPopupMessage]=useState({state:false,type:"",message:""})
const [loading,setLoading]=useState(false)
 
   
    const value = {
        popupMessage,setPopupMessage,
        loading,setLoading

    }

    return (
        <PupupContext.Provider value={value}>
            {props.children}
        </PupupContext.Provider>
    );
}
